// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'roboto-fontface/css/roboto/sass/roboto-fontface.scss';
import 'material-design-icons-iconfont/dist/material-design-icons.scss';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMoment from 'vue-moment';
import Axios from 'axios';

import './config.js';
import routes from './routes.js';
import App from './App';

import PageContent from './components/PageContent';
import DocsComponent from './components/DocsComponent';
import ExampleBox from './components/ExampleBox';
import ApiTable from './components/ApiTable';
import CodeBlock from './components/CodeBlock';

Vue.component('page-content', PageContent);
Vue.component('docs-component', DocsComponent);
Vue.component('example-box', ExampleBox);
Vue.component('api-table', ApiTable);
Vue.component('code-block', CodeBlock);

Vue.use(VueRouter);
Vue.use(VueMoment);

Axios.defaults.baseURL = 'http://premier.intelligence.id/v1';
//Axios.defaults.baseURL = 'http://localhost:5001/v1';
//Axios.defaults.baseURL = 'http://dev.premier.intelligence.id/v1';
Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');

export default Vue;

export var router = new VueRouter({
  mode: 'hash',
  base: window.location.pathname,
  routes
});

// eslint-disable-next-line
let Docs = Vue.component('app', App);
let handleSectionTheme = (currentRoute) => {

  let theme = 'default';
  // let theme = 'cyan';
  let name = currentRoute.name;

  if (name) {
      /* administrative */
    if (name === 'administrative:entry') {
      theme = 'blue';
    } else if (
        name === 'administrative:request' ||
        name === 'keyguard:request'
      ) {
      theme = 'teal';
    } else if (
        name === 'administrative:status' ||
        name === 'keyguard:status' ||
        name === 'administrative:status_checkin'
      ) {
      theme = 'brown';
    } else if (
        name === 'administrative:history' ||
        name === 'keyguard:history' ||
        name === 'administrative:status_checkout'
      ) {
      theme = 'indigo';
    } else if (
        name === 'administrative:reports' ||
        name === 'keyguard:reports' ||
        name === 'administrative:status_all'
      ) {
      theme = 'purple';
      /* common */
    } else if (name === 'preference:profile') {
      theme = 'orange';
    } else if (name === 'preference:password') {
      theme = 'green';
    } else if (name === 'maps') {
      theme = 'blue-grey';
    } else if (name === 'error') {
      theme = 'red';
    }
  }

  Vue.material.setCurrentTheme(theme);
};

/* eslint-disable no-new */
Docs = new Docs({
  el: '#app',
  router
});

handleSectionTheme(router.currentRoute);

router.beforeEach((to, from, next) => {
  Vue.nextTick(() => {
    let mainContent = document.querySelector('.main-content');

    if (mainContent) {
      mainContent.scrollTop = 0;
    }

    Docs.closeSidenav();

    next();
  });
});

router.afterEach((to) => {
  if (localStorage.getItem('id_token') === null) {
    router.push({
      name: 'signin'
    });
  }
  handleSectionTheme(to);
});



// WEBPACK FOOTER //
// ./src/main.js